import WaitingXhrPage from "./components/WaitingXhrPage.vue";

const app = new Vue({
    el: '#cart-page-init',
    components: {WaitingXhrPage},
    data() {
        return {
            dto: cartPageInitDto,
            token: token
        }
    }
});
